import axios from "axios";
import { mainBaseUrl } from "@/apis/appconst";

const apiBaseUrl = mainBaseUrl + "api/v1";
import Cookies from "js-cookie";

export async function createBus(
  operator_id,
  travels_name,
  reg_no,
  bus_type,
  permit_type,
  color,
  capacity,
  make,
  district,
  base_location,
  base_pin_code
) {
  const token = Cookies.get("accessToken");

  const payload = {
    operator_id,
    travels_name,
    reg_no,
    bus_type,
    permit_type,
    color,
    capacity,
    make,
    district,
    base_location,
    base_pin_code,
  };

  try {
    const response = await axios.post(`${apiBaseUrl}/bus`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error response:", error);
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function getBusById(busId) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(`${apiBaseUrl}/bus/${busId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function getTripTimeTable(busId) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(
      `${apiBaseUrl}/bus/${busId}/trip/time-table`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function updateTripTimeTable(busId, timeTableData) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.patch(
      `${apiBaseUrl}/bus/${busId}/trip/time-table`,
      timeTableData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function getTripById(tripId) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(`${apiBaseUrl}/trip/${tripId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function updateTripStopTime(tripId, stopName, expectedTime) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.put(
      `${apiBaseUrl}/bus/${tripId}/trip/time-table`,
      {
        stop_name: stopName,
        expected_time: expectedTime,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return {
      success: true,
      type: "success",
      message: "Stop time updated successfully.",
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function getBusesByOperatorId(operatorId) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(
      `${apiBaseUrl}/bus/get-by-operator-id/${operatorId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function searchBus(searchKey) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(`${apiBaseUrl}/bus/search`, {
      params: {
        search_key: searchKey,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function getAllBuses(params) {
  const token = Cookies.get("accessToken");

  const queryParams = {
    page_no: params?.pageNo || 1,
    limit: params?.limit || 10,
    ascending: params?.ascending,
    ...(params?.phoneNumber && { phone_number: params?.phoneNumber }),
    ...(params?.regNo && { reg_no: params?.regNo }),
  };

  try {
    const response = await axios.get(`${apiBaseUrl}/bus`, {
      params: queryParams,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function updateBus(busId, busDetails) {
  const token = Cookies.get("accessToken");

  const payload = {
    travels_name: busDetails.travelsName,
    reg_no: busDetails.busRegNo,
    bus_type: busDetails.busType,
    permit_type: busDetails.permitType,
    color: busDetails.busColor,
    capacity: busDetails.busCapacity,
    make: busDetails.busMake,
    district: busDetails.busDistrict,
    base_location: busDetails.baseLocation,
    base_pin_code: busDetails.pincode,
  };

  try {
    const response = await axios.put(`${apiBaseUrl}/bus/${busId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return {
      success: true,
      type: "success",
      message: "Bus updated successfully.",
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function deleteBus(busId) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.delete(`${apiBaseUrl}/bus/${busId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return {
      success: true,
      type: "success",
      message: "Bus deleted successfully.",
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function uploadBusImage(file, bus_id, image_type) {
  const token = Cookies.get("accessToken");

  if (!token) {
    return {
      status: false,
      type: "danger",
      message: "Access token not found. Please login again.",
    };
  }

  const formData = new FormData();
  formData.append("images", file);
  formData.append("entity_id", bus_id);
  formData.append("entity_type", "bus");
  formData.append("image_type", image_type);

  try {
    const response = await axios.post(`${apiBaseUrl}/bus/images`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return {
      status: true,
      type: "success",
      message: "Image uploaded successfully.",
      data: response.data,
    };
  } catch (error) {
    console.log(error, "Images error");

    return {
      status: false,
      type: "danger",
      message: error.response?.data?.message || error.message,
    };
  }
}

export async function getBusImage(busId) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.get(`${apiBaseUrl}/bus/images/${busId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return {
      success: true,
      type: "success",
      message: "Bus image fetched successfully.",
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function deleteBusImage(imageId) {
  const token = Cookies.get("accessToken");

  try {
    const response = await axios.delete(`${apiBaseUrl}/bus/images/${imageId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return {
      success: true,
      type: "success",
      message: "Image deleted successfully.",
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function updateBusImage(imageId, imageFile, imageType) {
  console.log(imageType)
  const token = Cookies.get("accessToken");

  const formData = new FormData();
  formData.append("image", imageFile);
  formData.append("image_type", imageType);

  try {
    const response = await axios.patch(
      `${apiBaseUrl}/bus/images/${imageId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return {
      success: true,
      type: "success",
      message: "Image type updated successfully.",
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}
